import { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { Image } from '@codes/ui-kit/components/ui/image';

import { GithubDarkIcon, GithubIcon, LinkedinDarkIcon, LinkedinIcon, LogoDarkImage, LogoImage } from '@codes/assets';
import { PrivacyTermsDialog } from '@codes/shared';

export const Footer = ({ setFooterHeight }: { setFooterHeight: (height: number) => void }) => {
    const { t } = useTranslation();
    const navigate = useNavigate();

    const footerRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        const updateHeight = () => {
            if (footerRef.current) {
                setFooterHeight(footerRef.current.clientHeight);
            }
        };

        updateHeight();
        window.addEventListener('resize', updateHeight);
        return () => window.removeEventListener('resize', updateHeight);
    }, []);

    return (
        <footer
            ref={footerRef}
            className="py-[118px] max-xs:py-[90px] px-12 bg-background flex flex-col items-center font-medium"
        >
            <Image className="h-9" src={LogoImage} darkSrc={LogoDarkImage} />
            <div className="mt-[15px] text-[17px] text-center text-[#53555B] dark:text-[#CFD0D3]">
                Stress-free AI DevOps; From Infrastructure to Scalable Microservices.
            </div>
            <div className="my-[29px] flex items-center gap-5">
                <a
                    href="https://github.com/lemoncloud-io"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="w-11 h-11 rounded-full flex items-center justify-center bg-[#F0F0F0] dark:bg-[#3A3D40]"
                >
                    <Image src={GithubIcon} darkSrc={GithubDarkIcon} />
                </a>
                <a
                    href="https://www.linkedin.com/company/lemoncloud/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="w-11 h-11 rounded-full flex items-center justify-center bg-[#F0F0F0] dark:bg-[#3A3D40]"
                >
                    <Image src={LinkedinIcon} darkSrc={LinkedinDarkIcon} />
                </a>
            </div>
            <div className="text-[#84888F] dark:text-[#9FA2A7] text-[15px]">
                © 2025 LemonCloud, Inc. All rights reserved.
            </div>
            <div className="text-[#84888F] dark:text-[#9FA2A7] flex items-center gap-1 mt-[10px]">
                <PrivacyTermsDialog />
            </div>
        </footer>
    );
};
